export const Identifiers = {
  isAppliance: {
    // eslint-disable-next-line id-length
    read(_, { readField }) {
      const productType = readField('productType');
      return !!(productType?.toUpperCase() === 'MAJOR_APPLIANCE');
    }
  }
};
